import styles from './FooterCopyright.module.css';

const FooterCopyright = () => {
    const currentYear = new Date().getFullYear();

  return (
    <div className={styles.copyrightContainer}>
      <p className={styles.text}>
        © {currentYear} SAMANTHA OLGUIN. All Rights Reserved.
      </p>
    </div>
  );
};

export default FooterCopyright;
